__webpack_require__.p = "https://static.age.awaze.com/postbook-auth-mfe/da76ccb3dfe00dd2d8705ea36cbed41677cf062d/_next/";